/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const deleteApiAlbumCollectionsIdAlbumsPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор выпуска")
    })

export const deleteApiAlbumCollectionsIdAlbumsQueryParamsSchema = z.object({
    "AlbumIds": z.array(z.string().uuid()).describe("Идентификаторы альбомов")
    })

/**
 * @description Альбомы удалены из выпуска
 */
export const deleteApiAlbumCollectionsIdAlbums200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const deleteApiAlbumCollectionsIdAlbums400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const deleteApiAlbumCollectionsIdAlbums401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const deleteApiAlbumCollectionsIdAlbums403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Выпуск не найден
 */
export const deleteApiAlbumCollectionsIdAlbums404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const deleteApiAlbumCollectionsIdAlbums500Schema = z.lazy(() => badResponseModelSchema)

export const deleteApiAlbumCollectionsIdAlbumsMutationResponseSchema = z.lazy(() => deleteApiAlbumCollectionsIdAlbums200Schema)